import { isNil } from 'lodash'
import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { photoUpdate } from '../../../action/photo-actions';
import ImageValue from '../../../asset/GreenIcon.png'
import { createContent } from '../commonFunctions'
import { infoWindowOpenAction, infoWindowCloseAction } from '../../../action/infowindow-action'
import { photoDeleteRequest } from '../../../action/photo-actions'
import ConfirmRemoval from '../../../component/main-ui/left-toolbar/common/confirm-remove/index'
import './photo.css'
import { enableMapObject, disableMapObject } from '../../../action/disable-map-obj-state-action'
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id'

const buildPhotoContent = (url, color) => {
  let colorMarker
  if (color.length <= 6 || color.length <= 7) {
    colorMarker = color[0] == '#' ? color : '#' + color
  } else {
    colorMarker = color[0] == '#' ? color.substring(2) : '#' + color.substring(2)
  }
  const content = document.createElement("div");
  content.classList.add("photo-property");
  content.innerHTML = `
  <div style="height: 30px; width: 30px; border: 2px solid ${colorMarker}; border-radius: 50%; overflow: hidden;margin-bottom: 5px; position: relative;background-color: ${colorMarker}">
  <img style="height: 30px; width: 30px; object-fit: cover; position: absolute; top: 0; left: 0;" src="${url ? url : 'https://images.unsplash.com/photo-1575936123452-b67c3203c357?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1hZ2V8ZW58MHx8MHx8fDA%3D'}" alt="Image">
  </div>
  <div class="triangle-style-mouse-handler" style="border-top: 13px solid ${colorMarker}" ></div>
  `
  return content;
}

const RenderPhotos = (props) => {
  const [comfirmRemove, setComfirmRemove] = useState(false)
  const [deleteMarkerId, setDeleteMarkerId] = useState('NAN')
  const [infowindowsState, setInfowindowsState] = useState(null)
  const [previousState, setPreviousState] = useState(null)

  const nulTheMapRefPhoto = useRef(null);
  const photoMarkerRefs = useRef({});  // Add this to track markers on the map
  const { photos, mapReference, auth, expandLeftToolbar, activeVendors, vendors, infoWindow, photoDeleteRequest, infoWindowOpenAction, collapseLeftToolbar, selectedObjectId, selectedObjectIdNull } = props;
  let openInfoWindowClose = null
  let token = auth.token

  const handleRemoveFunction = () => {
    if (nulTheMapRefPhoto.current) {
      nulTheMapRefPhoto.current(deleteMarkerId)
      setComfirmRemove(false)
    }
  }

  useEffect(() => {
    if (infoWindow && infoWindow.infoWindowFunction) {
      infoWindow.infoWindowFunction.close()
    }
    setPreviousState(infowindowsState);
    if (infoWindow.infoWindowFunction) {
      infoWindowOpenAction(infowindowsState)
    }
    checkAndClose()
  }, [infowindowsState])


  let storeInfoBox = (value) => {
    setInfowindowsState(value);
    infoWindowOpenAction(value)
  }

  let checkAndClose = () => {
    if (previousState) {
      previousState.close()
    }
  }

  const photoRenderFunction = async (toAdd) => {
    let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
    let newPhotsValue = []
    if (toAdd.length > 0) {
      toAdd.forEach(photo => {
        if (!photoMarkerRefs.current[photo.id]) {  // Only add marker if not already on the map
        } else {
          photoMarkerRefs.current[photo.id].map = null
          // Remove the marker from photoMarkerRefs.current
          delete photoMarkerRefs.current[photo.id];
        }
        if (photo.latitude || photo.longitude) {
          const url = photo.thumbnailUrl;
          const color = photo.color ? photo.color : '9ECC3B';
          const mapObj = new AdvancedMarkerElement({
            map: mapReference,
            content: buildPhotoContent(url, color),
            position: { lat: photo.latitude ? photo.latitude : 0, lng: photo.longitude ? photo.longitude : 0 },
            title: photo.name ? photo.name : 'Not Available',
          })
          photo['measureType'] = 'photo'
          photo['mapObj'] = function () { return mapObj }
          mapObj.addListener('click', renderPhoto)
          function renderPhoto() {
            selectedObjectId(photo.id)
            newPhotsValue.push(mapObj)
            const editFunction = (infoWindow) => {
              collapseLeftToolbar()
              expandLeftToolbar({ dialog: 'edit', editable: photo, mapObj: mapObj })
              // disableMapObject()
              google.maps.event.clearListeners(mapObj, 'click');
              openInfoWindowClose = infoWindow;
              setInfowindowsState(infoWindow)
              openInfoWindowClose.close();
              // infoWindowOpenAction(null)
              setInfowindowsState(null)
              mapReference.setCenter({ lat: photo.latitude, lng: photo.longitude })
              mapReference.setZoom(17);
              selectedObjectIdNull()
            }
            const clearTheObj = async (value) => {
              try {
                let res = await photoDeleteRequest(value);
                mapObj.map = null;
              } catch (error) {
                console.log('Error at deleteFunction', error)
              }
            };
            const deleteFunction = (value) => {
              setDeleteMarkerId(value)
              setComfirmRemove(true);
              nulTheMapRefPhoto.current = clearTheObj;
              openInfoWindowClose.close();
              setInfowindowsState(null)
              selectedObjectIdNull()
              // infoWindowOpenAction(null)
            }
            const closeFunction = (infoWindow) => {
              openInfoWindowClose = infoWindow;
              openInfoWindowClose.close();
              // infoWindowOpenAction(null)
              setInfowindowsState(null)
              selectedObjectIdNull()
            }
            const updateInfoWindow = (value) => {
              openInfoWindowClose = value
            }
            const dispatchFunction = (value) => {
              storeInfoBox(value)
            }
            createContent({ mapReference, mapObj, photo, infoWindow, openInfoWindowClose, token }, { deleteFunction, closeFunction, editFunction, updateInfoWindow }, dispatchFunction);
          }
          photoMarkerRefs.current[photo.id] = mapObj;  // Track added marker by id
        }
      })
    }
  }

  const vendorPhotos = activeVendors.map(id => {
    return vendors[id] && vendors[id]['objects'] && vendors[id]['objects']['photos'] ?
      vendors[id]['objects']['photos'].filter(photo => isNil(photo.mapObj)) : []
  }),
    toAdd = photos.filter(photo => isNil(photo.mapObj)).concat(vendorPhotos.flat())
  if (!isNil(mapReference) && toAdd.length > 0) {
    photos && photoRenderFunction(toAdd)
  }

  if (comfirmRemove) {
    return <ConfirmRemoval cancel={() => { setComfirmRemove(false) }} remove={() => handleRemoveFunction()} type="Photo" />;
  }
  else {
    return (
      null
    )
  }

}

const mapStateToProps = state => ({
  activeVendors: state.activeVendors,
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  photos: state.photos,
  auth: state.auth,
  infoWindow: state.infoWindow
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  photoUpdate: photo => dispatch(photoUpdate(photo)),
  infoWindowCloseAction: () => dispatch(infoWindowCloseAction()),
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
  photoDeleteRequest: (id) => dispatch(photoDeleteRequest(id)),
  disableMapObject: () => dispatch(disableMapObject()),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  selectedObjectId: (payload) => dispatch(selectedObjectId(payload)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull())
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderPhotos)